import { Deserializable } from '../protocols/deserializable';
import { AccountStatusEnum } from './enum/account-status.enum';

export class AccountStatusType implements Deserializable {
  public id!: AccountStatusEnum;
  public name!: string;

  public onDeserialize() {}
}
